export const environment = {
  production: false,
  surveyApiBaseUrl: 'https://erp.staging.imt.fi',
};
